module.exports = __webpack_public_path__ + "img/OR.ff4fb894.png";